import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import LoadingIndicator from "components/shared/LoadingIndicator";
import { MANAGE_NOTIFICATION_EMAIL_TEMPLATE_LIST, MANAGE_NOTIFICATION_FIREBASE_TEMPLATE_EDIT } from "config/paths";
import { useGetTemplateListQuery } from "store/services/notification";
import { TEMPLATES_TITLE } from "config/constants";

const ManageFirebaseNotificationTemplate = () => {

    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(50);
    const [filter, setFilter] = useState({ type: "firebase", search: "", status: "", sort: { column: "id", direction: "desc" } });
    const { data, isLoading } = useGetTemplateListQuery({ page: currentPage, limit: pageSize, ...filter });
    const firebaseTemplateData = data?.records || [];


    return (
        <>
            <section className="ManageDiscriplines position-relative py-4">
                <Container fluid={true}>
                    <Row>
                        <Col lg="12" className="my-2">
                            <div className="TableFilter d-flex align-items-center justify-content-between gap-10 flex-wrap">
                                <div className="left">
                                    <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center gap-10 flex-wrap">
                                        <li className="">
                                            <h6 className="m-0 fw-bold themeBlue">
                                                Firebase Notifications
                                            </h6>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </Col>
                        {
                            isLoading ? <LoadingIndicator /> : (
                                <Col lg="12" className="my-2">

                                    <div className="w-100">
                                        <Row className="justify-content-between mt-2">
                                            <Col md="12" className="my-1">
                                                <ul className="list-unstyled ps-0 mb-0">
                                                    {
                                                        firebaseTemplateData?.map((item, index) => {

                                                            return (
                                                                <li key={index} className="py-2 d-flex align-items-start gap-10  border-bottom my-3">
                                                                    <h6
                                                                        style={{ fontSize: 12, cursor: "pointer" }}
                                                                        className="w-50 themeBlue fw-bold text-capitalize"
                                                                        onClick={() => navigate(MANAGE_NOTIFICATION_FIREBASE_TEMPLATE_EDIT.replace(":id", item?.id))}
                                                                    >
                                                                        {item?.firebase_heading?.replace(/&amp;/g, "&") || "--"}
                                                                    </h6>
                                                                    <p style={{ width: "250px", textOverflow: "ellipsis", overflow: "hidden", textWrap: "nowrap" }} className="m-0 forteen text-muted w-50">{item?.template_desc || "--"}</p>
                                                                </li>
                                                            )
                                                        })
                                                    }
                                                </ul>
                                            </Col>
                                        </Row>

                                    </div>
                                </Col>
                            )
                        }
                    </Row>
                </Container>
            </section>
        </>
    );
};

export default ManageFirebaseNotificationTemplate;
